<template>
    <div class="col-sm-12">
        <div id="cdl_xp_pie" style="min-height:40em"></div>
    </div>
</template>

<script>
    export default {
        props: [
            'data',
            'activeTab',
        ],
        watch: {
            data() {
                this.refresh();
            },
            activeTab() {
                if (this.activeTab == 'experience') this.refresh();
            }
        },
        methods: {
            isGoogleChartsLoaded() {
                return typeof google !== 'undefined' && google.visualization && typeof google.visualization.arrayToDataTable === 'function';
            },
            refresh() {
                if (!this.isGoogleChartsLoaded()) return;
                var data = google.visualization.arrayToDataTable(
                    _.concat(
                        [['Class A CDL Experience', '# Leads']],
                        _.map(this.data.cdlXp, (value, key) => [ key, value ])
                    )
                );
                var options = {
                    colors: ['#13406d'],
                    legend: 'none'
                };

                var chart = new google.visualization.ColumnChart(document.getElementById('cdl_xp_pie'));
                chart.draw(data, options);
            },
        },
    }
</script>
